/**
 * Loading Spinner Component
 */

import React from 'react';

export function LoadingSpinner({ size = 'md', className = '' }) {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <div
      className={`${sizes[size]} ${className} border-4 border-border border-t-primary rounded-full animate-spin`}
      role="status"
      aria-label="Loading"
    />
  );
}
